import * as React from "react";
import "../BooksSidebar.css";
import cn from "classnames";
import { MOBILE_MAX_WIDTH } from "../../../../utils";
import MediaQuery from "react-responsive";
import BookFind from "../BookFind/BookFind";
import BookChip from "../BookChip/BookChip";
import { LibraryCard } from "../../../../types/LibraryCard";
import Select from "@material-ui/core/Select/Select";
import MenuItem from "@material-ui/core/MenuItem/MenuItem";
import { Sections } from "../BooksSidebar";
import WelcomeBook from "../../../WelcomeBook/WelcomeBook";
import { CallbacksContext } from "../../BookCalendar";
import CategoriesWrapper from "./CategoriesWrapper/CaategoriesWrapper";
import { useParams } from "react-router-dom";

interface Props {
	sectionName: string;
	books: LibraryCard[];
	selectedBookId?: number;
	onCardSelect: (bookId: number) => void;
	emptyText: string;
	type?: Sections;
	onChangeSection?: (type: Sections) => void;
}

const BookSection: React.FunctionComponent<Props> = (props) => {
	const params = useParams<{
		category: string
	}>();

	const [filteredBook, setFilteredBook] = React.useState<string>(null);
	const [selectedCollection, setCollection] = React.useState(params?.category ? parseInt(params.category) : null);

	const filteredBooks = React.useMemo(() => {
		let cards = props.books;

		if (filteredBook) {
			cards = cards.filter(
				(card) => card.book.name.toLowerCase().indexOf(filteredBook) >= 0
			);
		}

		if (selectedCollection) {
			cards = cards.filter(
				(card) => card.book?.collection?.id === selectedCollection
			);
		}

		return cards;
	}, [props.books, filteredBook, selectedCollection]);

	const onSearchChange = (value: string) => {
		setFilteredBook(value.toLowerCase());
	};

	const onSearchClose = () => {
		setFilteredBook(null);
	};

	const callbacks = React.useContext(CallbacksContext);

	return (
		<div className={cn("books-sidebar-section")}>
			<MediaQuery minWidth={MOBILE_MAX_WIDTH}>
				<BookFind
					onInputChanged={onSearchChange}
					onClose={onSearchClose}
					disabled={props.books.length === 0}
				>
					<div className="books-sidebar-section__name">{props.sectionName}</div>
				</BookFind>
			</MediaQuery>

			<MediaQuery maxWidth={MOBILE_MAX_WIDTH}>
				<BookFind
					onClose={onSearchClose}
					onInputChanged={onSearchChange}
					className="book-calendar-find"
					disabled={props.books.length === 0}
				>
					<div className="">
						<Select
							className="book-calendar__section__select"
							value={props.type}
							onChange={(e) => {
								props.onChangeSection(e.target.value as Sections);
							}}
							disableUnderline={true}
						>
							<MenuItem value={Sections.ReadNow}>Читаю сейчас</MenuItem>
							<MenuItem value={Sections.WantRead}>Хочу прочитать</MenuItem>
							<MenuItem value={Sections.AlreadyRead}>Прочитано</MenuItem>
							<MenuItem value={Sections.All}>Все</MenuItem>
						</Select>

						<div className="book-calendar__section__select__hint">
							Коснитесь, что сменить категорию
						</div>
					</div>
				</BookFind>

				<CategoriesWrapper
					cards={filteredBooks}
					setCollection={setCollection}
					selectedCollection={selectedCollection}
				/>
			</MediaQuery>

			{filteredBooks.length > 0 && (
				<div className="books-sidebar-section__books">
					{filteredBooks.map((card) => {
						return (
							<BookChip
								card={card}
								key={card.eId}
								isSelected={card.eId === props.selectedBookId}
								onClick={() => {
									props.onCardSelect(card.eId);
								}}
							/>
						);
					})}
				</div>
			)}

			{filteredBooks.length === 0 && (
				<div className="books-sidebar-section__emptyText">
					{filteredBook ? (
						"В вашей библиотеке нет книг с таким названием"
					) : (
						<>
							<WelcomeBook callbacks={callbacks} />
						</>
					)}
				</div>
			)}
		</div>
	);
};

export default BookSection;
